import React, { useState, useMemo } from 'react'
import { Button, DatePickerRange, Toast } from '@ow/comps'
import { pick } from 'lodash-es'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import locale from '@ow/comps/locale/zh-CN'
import useProjectStore from '@vt/hooks/lib/project/use-project-store'
import { getDownloadUrl } from '@vt/apis/lib-ex/v2/givrali'
import { reportTaskSyhjws } from '@vt/apis/lib-ex/v2/exportAreaFile'
import dayjs from 'dayjs'

const { hostname = '' } = window.location || {}
const isProd = hostname.startsWith('ow.survey.work')
const Exporter = function () {
  const { appId } = useAppEx()
  const { getToken } = useProjectStore((s) => pick(s, ['getToken']))
  const token = getToken()
  const { tbSlug } = useTbViewStore((state) => pick(state, ['tbSlug']))
  const [timeRange, setTimeRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ])
  const tbSlugReportApiMap = {
    anjianliebiao_f958f59d_da44_4ca5_9146_d2ceed78ecd7: {
      exportFn: reportTaskSyhjws,
      exportTbId: isProd ? 1902 : 2928,
    },
  }
  const [showTime] = useState(true)
  const childQueries = useMemo(() => {
    const { startDate, endDate } = timeRange[0]
    return [
      {
        queryType: 'just',
        queryOperate: {
          slug: 'createdAt',
          operator: 'gte',
          rightValue: startDate
            ? new Date(startDate).getTime()
            : dayjs(Date.now()).startOf('day').valueOf(),
        },
      },
      {
        queryType: 'just',
        queryOperate: {
          slug: 'createdAt',
          operator: 'lte',
          rightValue: endDate
            ? new Date(endDate).getTime()
            : dayjs(Date.now()).endOf('day').valueOf(),
        },
      },
      {
        queryType: 'not',
        yacQueryOperate: {
          operator: 'equal',
          left: {
            slug: 'isFakeDeleted',
          },
          right: {
            value: true,
          },
        },
      },
    ]
  }, [timeRange])
  const exporterFn = () => {
    const send = {
      queryType: 'and',
      childQueries,
      size: 50,
      page: 0,
    }
    const { exportFn, exportTbId } = tbSlugReportApiMap[tbSlug]
    if (!exportFn || !exportTbId) return
    exportFn(exportTbId, send).then((res) => {
      const { ossUrl = '' } = res || {}
      Toast.success({
        title: '下载成功',
      })
      const fileName = ossUrl.split('/')[ossUrl.split('/').length - 1]
      window.open(getDownloadUrl(appId, fileName, ossUrl, token))
    })
  }
  if (Object.keys(tbSlugReportApiMap).includes(tbSlug)) {
    return (
      <div
        className="flex pl-3 gap-3 items-center"
        style={{
          height: '56px',
        }}
      >
        <DatePickerRange
          ranges={timeRange}
          locale={locale}
          inputStyle={{ width: '220px' }}
          placeholder="请选择导出时间"
          selectedDateBackground="rgb(var(--ow-primary-color))"
          showTime={showTime}
          onChange={(date) => {
            if (date[0].startDate !== date[0].endDate) {
              setTimeRange(date)
            }
          }}
        />

        <Button type="primary" onClick={() => exporterFn()}>
          点位统计
        </Button>
      </div>
    )
  }
  return ''
}

export default Exporter
